<template>
	<div>
		<modalconfirm ref="modalconfirmRetur" @action="proccessRetur"/>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Retur</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-retur' }" v-if="hasAccess('add-retur')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Retur</div>
							</v-btn>
						</router-link>
						<div class="ml-4">
							<v-tabs color="primary" background-color="deep-purple lighten-5" class="change-display" height="40">
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="2" >
								<v-text-field outlined dense hide-details label="Kode Retur" v-model="por_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalRetur)" label="Tanggal Retur" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal"></v-text-field>
									</template>
									<v-date-picker locale="id" first-day-of-week="0" range color="primary" v-model="tanggalRetur" :max="today"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="4">
								<v-autocomplete item-text="" outlined dense hide-details v-model="por_status.value" :items="OptionStatusRetur" label="Status" no-data-text="Tidak ada data yang sesuai">
									<template v-slot:item = {item}>
										{{item | toStatusReturWH}}
									</template>
									<template v-slot:selection = {item}>
										{{item | toStatusReturWH}}
									</template>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
					<v-card-actions class="px-4" v-if="false">
						<v-spacer></v-spacer>
						<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
						<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
					</v-card-actions>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table loading :headers="headers" :items="listRetur" hide-default-footer :options.sync="option" :server-items-length="returPagination.total_data" disable-pagination>
					<template v-slot:item.created_datetime="{ item }">
						<div class="pt-2">{{ item.por_status_created_datetime | tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-btn x-small dense text color="grey darken-1" class="pl-0" @click="printRetur(userData.user_warehouse_id, item.por_code)"><v-icon>mdi-printer</v-icon></v-btn>
						</div>
					</template>
					<template v-slot:item.por_code="{ item }">
						<div>{{ item.por_code }}</div>
					</template>
					<template v-slot:item.por_note="{ item }">
						<div>{{ item.por_note ? item.por_note : '-' }}</div>
					</template>
					<template v-slot:item.supplier="{ item }">
						<div class="py-2">
							<div>{{ item.supplier_name }}</div>
							<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.supplier_mobilephone }}</span></div>
							<div class="pt-1"><v-icon small>mdi-email</v-icon><span class="pl-2">{{ item.supplier_email }}</span></div>
						</div>
					</template>
					<template v-slot:item.status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.por_status | toStatusReturWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.por_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
							<v-tooltip bottom v-if="item.por_status == 'created' && hasAccess('approve-retur')">
								<template v-slot:activator="{ on, attrs }">
									<router-link class="text-deco" :to="{ name: 'approve-retur', params: { code: item.por_code }}">
										<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on" class="mr-2">
											<v-icon dark>mdi-check</v-icon>
										</v-btn>
									</router-link>
								</template>
								<span>Approve</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!returPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card outlined v-if="listRetur.length == 0 && returPagination">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="retur in listRetur" :key="retur.por_id">
					<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Retur {{ retur.por_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="primary" @click="printRetur(userData.user_warehouse_id, retur.por_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Supplier</div>
									<div class="subtitle-2">{{ retur.supplier_name }}</div>
									<div class="body-2 pt-3">
										<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ retur.supplier_mobilephone }}</span>
									</div>
									<div class="body-2 pt-1">
										<v-icon small>mdi-email</v-icon><span class="pl-2">{{ retur.supplier_email }}</span>
									</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Tanggal Retur</div>
									<div class="subtitle-2">{{ retur.por_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3>
									<div class="body-2 oppacity-75">Catatan</div>
									<div class="subtitle-2 text-capitalize">{{ retur.por_note ? retur.por_note : '-' }}</div>
								</v-flex>
								<v-flex xs6 sm3 md3 class="pl-3">
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ retur.por_status | toStatusReturWH }}</div>
									<div class="pt-3">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(retur.por_code)">
													<v-icon dark>mdi-text-box-search</v-icon>
												</v-btn>
											</template>
											<span>Detail</span>
										</v-tooltip>
										<v-tooltip bottom v-if="retur.por_status == 'created' && hasAccess('approve-retur')">
											<template v-slot:activator="{ on, attrs }">
												<router-link class="text-deco" :to="{ name: 'approve-retur', params: { code: retur.por_code }}">
													<v-btn fab dark x-small depressed color="indigo lighten-2" v-bind="attrs" v-on="on" class="ml-2">
														<v-icon dark>mdi-check</v-icon>
													</v-btn>
												</router-link>
											</template>
											<span>Approve</span>
										</v-tooltip>
									</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
					<div class="pt-3">
						<v-card elevation="0">
							<v-data-table :headers="headersProduct" :items="retur.por_detail" :items-per-page="1000" class="elevation-0" hide-default-footer>
								<template v-slot:item.por_detail_product_price="{ item }">
									<div>{{ item.por_detail_product_price | toNumber }}</div>
								</template>
								<template v-slot:item.por_detail_quantity_requested="{ item }">
									<div v-if="retur.por_status == 'created'">
										{{ item.por_detail_quantity_requested | toNumber }}
									</div>
									<div v-else>
										{{ item.por_detail_quantity_approved | toNumber }}
									</div>
								</template>
								<template v-slot:item.por_detail_quantity_delivered="{ item }">
									<div>{{ item.por_detail_quantity_delivered | toNumber }}</div>
								</template>
								<template v-slot:item.por_detail_quantity_transport="{ item }">
									<div>{{ item.por_detail_quantity_transport | toNumber }}</div>
								</template>
								<template v-slot:item.sub_total="{ item }">
									<div v-if="retur.por_status == 'created'">
										{{ item.por_detail_quantity_requested * item.por_detail_product_price | toNumber }}
									</div>
									<div v-else>
										{{ item.por_detail_quantity_approved * item.por_detail_product_price | toNumber }}
									</div>
								</template>
							</v-data-table>
							<!-- <div class="d-flex justify-end py-2">
								<div class="font-weight-bold text-right px-4">Total Pembayaran</div>
								<div class="font-weight-bold text-right px-4">{{ countGrandtotal(retur.por_detail, retur.por_status) | toRupiah }}</div>
							</div> -->
						</v-card>
					</div>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row v-if="returPagination">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination @input="changePage" v-model="page" :length="returPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'
import modalDetail from '@/views/MLwarehouse/retur/DetailRetur'
import modalPrint from '@/views/MLwarehouse/retur/PrintRetur'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: true,
			menu: false,
			loading: true,
			tanggalRetur: [],
			por_code: {
				value:'',
				comparison: 'like',
				type: 'string',
				field: 'por_code'
			},
			por_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'por_status_created_datetime'
			},
			por_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'por_status'
			},
			sortBy: 'por_id',
			sortDir: 'DESC',
			page: 1,
			limit: '10',
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			headers: [
			{ text: 'Tanggal Retur', value: 'created_datetime' },
			{ text: 'Kode Retur', sortable: true, value: 'por_code'},
			{ text: 'Supplier', value: 'supplier'},
			{ text: 'Catatan', value: 'por_note', width: "35%"},
			{ text: 'Status', value: 'status' },
			],
			headersProduct: [
			{ text: 'Nama Produk', value: 'por_detail_product_name', sortable: false },
			{ text: 'Jumlah Pesanan', value: 'por_detail_quantity_requested', align: 'center', sortable: false },
			{ text: 'Jumlah Diterima', value: 'por_detail_quantity_delivered', align: 'center', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'por_detail_quantity_transport', align: 'center', sortable: false },
			],
			params:[],
			procces_por_id: '',
			poProccess : '',
		}
	},
	computed: {
		...mapState('retur', ['listRetur', 'returPagination', 'OptionStatusRetur']),
		...mapState('auth', ['userData']),

	},
	methods: {
		...mapActions('retur', ['getRetur', 'deleteRetur', 'getDetailRetur', 'exportRetur', 'getOptionStatusRetur']),
		...mapMutations('retur', ['clearDataRetur']),
		...mapActions('common', ['getLetterHeader']),
		...mapMutations(['setOverlay']),

		getData() {
			this.getRetur(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData() {
			this.exportRetur(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		countGrandtotal(item, status) {
			let total = 0
			item.forEach( (el) => {
				let price = el.por_detail_product_price ? el.por_detail_product_price : 0
				let quantity = status == 'created' ? el.por_detail_quantity_requested : el.por_detail_quantity_approved
				total += price * quantity
			});

			return total
		},
		resetFilter() {
			this.por_code.value = ''
			this.por_date.value = ''
			this.tanggalRetur = []
			this.por_status.value = ''
			this.page = 1
			this.getData()
		},
		cari() {
			this.params = []
			if (this.por_code.value)
				this.params.push(this.por_code)
			if (this.por_date.value) {
				if (this.por_date.value.length > 1) {
					this.por_date.value.sort()
					let date = this.por_date.value.join('::')
					this.por_date.value = date
				}
				this.params.push(Object.assign({}, this.por_date))
			}
			if (this.por_status.value)
				this.params.push(this.por_status)
			this.page = 1
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		hapus(val) {
			this.procces_por_id = val
			this.poProccess = 'delete'
			let msg = "Yakin akan menghapus Retur ini?"
			this.$refs.modalconfirmRetur.showConfirm()
			this.$refs.modalconfirmRetur.setMessage(msg)
		},
		async proccessRetur() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmRetur.hideConfirm()
			if (this.poProccess == 'delete') {
				await this.deleteRetur(this.procces_por_id).then( () => {
					this.getData()
				})
			}
			await this.setOverlay(false)
		},
		getDetail(code) {
			this.getDetailRetur(code).then(()=> {
				this.dialog = true
			})
		},
		async printRetur(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailRetur(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Retur`)
		await this.getData()
		await this.getOptionStatusRetur()
		this.loading = await false
	},
	beforeDestroy() {
		this.clearDataRetur()
	},
	watch: {
		tanggalRetur(val) {
			this.por_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>